import dayjs, { Dayjs } from "dayjs";
import { toOpsUtcBound } from "../OpsTat/OpsTatFilters";

export type PodRevenueSortBy =
  | "gross_revenue"
  | "selling_exclusive"
  | "handling"
  | "shipping"
  | "gst"
  | "units"
  | "orders"
  | "order_date";

export type PodRevenueSortType = "ASC" | "DESC";

/** Same shape as redemption: date range + Order ID + Customer. */
export interface PodRevenueAppliedFilters {
  from: Dayjs;
  to: Dayjs;
  order_id: number[];
  customer_id: number[];
  q: string;
}

/** JSON body for analytics-server POD revenue endpoints. */
export interface PodRevenueRequestBody {
  start_date?: string;
  end_date?: string;
  order_id: number[];
  customer_id: number[];
  q?: string;
  product_id?: number;
  page: number;
  page_size: number;
  sort_by: PodRevenueSortBy;
  sort_type: PodRevenueSortType;
}

export const defaultPodRevenueAppliedFilters = (): PodRevenueAppliedFilters => ({
  from: dayjs().subtract(29, "day").startOf("day"),
  to: dayjs().endOf("day"),
  order_id: [],
  customer_id: [],
  q: "",
});

/** Order ID / customer each drop the date window (mirrors redemptionIgnoresDate). */
export const podRevenueIgnoresDate = (
  applied: Pick<PodRevenueAppliedFilters, "order_id" | "customer_id">,
): boolean => applied.order_id.length > 0 || applied.customer_id.length > 0;

export const toPodRevenueRequestBody = (
  applied: PodRevenueAppliedFilters,
  page: number,
  page_size: number,
  sort_by: PodRevenueSortBy,
  sort_type: PodRevenueSortType,
  product_id?: number,
): PodRevenueRequestBody => ({
  ...(podRevenueIgnoresDate(applied)
    ? {}
    : {
        start_date: toOpsUtcBound(applied.from, "start"),
        end_date: toOpsUtcBound(applied.to, "end"),
      }),
  order_id: applied.order_id,
  customer_id: applied.customer_id,
  ...(applied.q?.trim() ? { q: applied.q.trim() } : {}),
  ...(product_id ? { product_id } : {}),
  page,
  page_size,
  sort_by,
  sort_type,
});
